import React, { useRef } from 'react';
import cs from 'classnames';
import SearchIcon from '@mui/icons-material/Search';
import styles from './Search.module.scss';

type TSearch = {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  placeHolder?: string;
  style?: any;
};

const Search: React.FC<TSearch> = ({ onChange, className, placeHolder, style }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleIconClick = () => {
    inputRef.current?.focus();
  };

  return (
    <div className={cs(styles.searchContainer, className)} style={style}>
      <SearchIcon onClick={handleIconClick} style={{ cursor: 'pointer' }} />
      <input ref={inputRef} onChange={onChange} placeholder={placeHolder ?? 'Search'} />
    </div>
  );
};

export default Search;
